import React, { PureComponent } from 'react';
import { Table, Input, message, DatePicker, ConfigProvider,Button,Select} from 'antd';
import API from '../../../../api/api';
import zhCN from 'antd/es/locale/zh_CN';

import './orderList.less';

const { RangePicker } = DatePicker;
const { Option } = Select;
class OrderList extends PureComponent {
    constructor(props) {
        super(props);

    }
    state = {
        searchData: {
            orderNo: '',//订单编号
            customerName: '',//
            customerMobile: '',//
            orderStatus: '',//
            payFromTime: '',//
            payToTime: '',//
        },
        columns: [],
        OrderListData: [],//订单数据列表
        loading: false,//加载数据过程
        pagination: {   //分页器参数
            hideOnSinglePage: true,
            showQuickJumper: true,
            showSizeChanger: false,
            addModalVisible: false,//添加或编辑对话框
            onShowSizeChange: this.onShowSizeChange,
            addModalTitle: '',
            pageSize: 5,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`,
            onChange: this.onPaginationChange
        },
        statusArr:new Map([
            ['01','预订'],['02','订单确认'],['03','交易完成'],['04','交易关闭']
        ])
    }
    componentDidMount() {
        //设置表头
        let columns = [
            {
                title: '订单编号',
                width: 300,
                dataIndex: 'orderNo',
                key: 'orderNo',
            },
            {
                title: '下单人姓名',
                width: 110,
                dataIndex: 'customerName',
                key: 'customerName',
            },
            {
                title: '下单人手机号',
                width: 160,
                dataIndex: 'customerMobile',
                key: 'customerMobile',
            },
            {
                title: '产品名称',
                width: 150,
                dataIndex: 'productName',
                key: 'productName',
            },
            {
                title: '购买数量',
                width: 100,
                dataIndex: 'psersonNum',
                key: 'psersonNum',
            },
            {
                title: '订单总金额',
                width: 110,
                dataIndex: 'mustReceivePrice',
                key: 'mustReceivePrice',
            },
            {
                title: '优惠金额',
                width: 100,
                dataIndex: 'preferentialMoney',
                key: 'preferentialMoney',
            },
            {
                title: '实付金额',
                width: 100,
                dataIndex: 'payPrice',
                key: 'payPrice',
            },
            {
                title: '下单时间',
                width: 160,
                dataIndex: 'orderDate',
                key: 'orderDate',
            },
            {
                title: '支付时间',
                width: 160,
                dataIndex: 'payDate',
                key: 'payDate',
            },
            {
                title: '支付流水号',
                width: 200,
                dataIndex: 'serialNumber',
                key: 'serialNumber',
            },
            {
                title: '退单时间',
                width: 160,
                dataIndex: 'refundDate',
                key: 'refundDate',
            },
            {
                title: '订单状态',
                width: 100,
                dataIndex: 'orderStatus',
                key: 'orderStatus',
            },
        ]
        this.setState({ columns })
        //填充数据
        let param = {
            pageIndex: 1,
            pageNum: 5
        }
        this.getOrderList(param);
    }
    onPaginationChange(pageCounter) {
    }
    onShowSizeChange(current, pageSize) {
    }
    searchForOrder() {
        const { pagination,searchData} = this.state;
        pagination.pageNum = 5;
        pagination.current=1;
        this.setState({pagination});
        let param={
            pageIndex: 1,
            pageNum: 5
        }
        for(let key in searchData){
            if(searchData[key]){
                param[key]=searchData[key]
            }
        }
        this.getOrderList(param);
    }
    async getOrderList(param) {
        //this.setState({ loading: true })
        let result = await API.getCaissaOrderList(param);
        if (!result) {
            this.setState({ loading: false })
            return;
        }
        if (result.status == 1) {
            const { pagination,statusArr} = this.state;
            pagination.total = Number(result.data.orderCount);
            pagination.pageSize = 5;
            let OrderListData = result.data.orderList;
            console.log(OrderListData)
            OrderListData.forEach((item)=>{
                if (item.payPrice && item.mustReceivePrice)
                    item.preferentialMoney = Number(item.mustReceivePrice - item.payPrice).toFixed(2);
                console.log(item.orderStatus)
                    item.orderStatus=statusArr.get(item.orderStatus);
            })
            this.setState({
                pagination,
                OrderListData,
                loading: false
            })
        }
        else if (result.status == "14014") {
            message.error(result.msg);
            this.setState({ loading: false })
        }
        else {
            message.error(result.msg);
            this.setState({ loading: false })
        }
    }
    onSearchChange = (type, e) => {// 搜索条件 ：订单编号 下单人姓名 下单人手机号
        let { searchData } = this.state;
        searchData[type] = e.target.value.trim();
        this.setState({
            searchData
        });
    }
    getZeroDate(value){
        let date=new Date(value);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date.getTime();
    }
    onSearchDateChange = date => { //筛选条件 ：时间范围
        let { searchData } = this.state;
        if(date.length==0){
            searchData['payFromTime']='';
            searchData['payToTime']='';
            return;
        }
        searchData['payFromTime'] =this.getZeroDate(date[0].valueOf());
        searchData['payToTime'] = this.getZeroDate(date[1].valueOf());
        this.setState({
            searchData
        });
    }
    onSelectChange = value =>{ // 筛选条件 ：订单状态
        let { searchData } = this.state;
        searchData['orderStatus']=value;
        this.setState({
            searchData
        });
    }

    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.pagination };
        const {searchData} =this.state;
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.setState({ pagination });
        let param={
            pageIndex:pager.current,
            pageNum: pager.pageSize
        }
        for(let key in searchData){
            if(searchData[key]){
                param[key]=searchData[key]
            }
        }
        this.getOrderList(param);
    };
    render() {
        const {
            columns,
            OrderListData,
            pagination,
            loading,
        } = this.state
        return (
            <ConfigProvider locale={zhCN}>
                <div className="OrderListPane">
                    <div className="searchBlock">
                        <div className="leftConditionBlock">
                            <div className="topSearchBlock">
                                <Input className="searchInput" width={100} placeholder="订单编号" onChange={this.onSearchChange.bind(this, 'orderNo')} />
                                <Input className="searchInput" placeholder="下单人姓名" onChange={this.onSearchChange.bind(this, 'customerName')} />
                                <Input className="searchInput" placeholder="下单人手机号" onChange={this.onSearchChange.bind(this, 'customerMobile')} />
                            </div>
                            <div className="bottomSearchBlock">
                                <RangePicker
                                    className="rangePicker"
                                    onChange={this.onSearchDateChange}
                                ></RangePicker>
                                <Select className="selectBlock" defaultValue="全部" onChange={this.onSelectChange}>
                                    <Option value="">全部</Option>
                                    <Option value="01">预订</Option>
                                    <Option value="02">订单确认</Option>
                                    <Option value="03">交易完成</Option>
                                    <Option value="04">交易关闭</Option>
                                </Select>
                            </div>
                        </div>
                        <div className="rightSearchBtn">
                            <Button type="primary" onClick={this.searchForOrder.bind(this)}>搜索</Button>
                        </div>

                    </div>
                    <Table columns={columns}
                        bordered
                        dataSource={OrderListData}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        loading={loading}
                        rowKey={row => row.id}
                        scroll={{ x: 1910 }}
                    />
                </div>
            </ConfigProvider>
        )
    }
}
export default OrderList;